import * as moment from 'moment';
import { isEmpty } from '../utils/validations';

export class AccountData {
    public completed: boolean;
    public skipped: boolean;
    public name: string;
    public firstSurname: string;
    public secondSurname: string;
    public birthdate: moment.Moment;
    public gender: 'M' | 'H';
    public state: string;
    public stateId: number;
    public curp: string;
    public validCurp: boolean;

    constructor(object?: any ) {
        object = object ? object : {};
        this.completed = isEmpty(object.completed) ? false : object.completed;
        this.skipped = isEmpty(object.skipped) ? false : object.skipped;
        this.name = isEmpty(object.name) ? '' : object.name;
        this.firstSurname = isEmpty(object.firstSurname) ? '' : object.firstSurname;
        this.secondSurname = isEmpty(object.secondSurname) ? '' : object.secondSurname;
        this.birthdate = isEmpty(object.birthdate) ? null : moment(object.birthdate);
        this.gender = isEmpty(object.gender) ? null : object.gender;
        this.curp = isEmpty(object.curp) ? null : object.curp;
        this.validCurp = isEmpty(object.validCurp) ? null : object.validCurp;
        this.state = isEmpty(object.state) ? null : object.state;
        this.stateId = isEmpty(object.stateId) ? null : object.stateId;
    }

    get birthDateStr(): string {
        return this.birthdate.format('DD/MM/YYYY');
    }

    get fullName(): string {
        return `${this.name} ${this.firstSurname} ${this.secondSurname}`;
    }
}
